"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
// eslint-disable-next-line import/prefer-default-export
exports.setGlobalMessage = function (message) { return toolkit_1.createAction(constants_1.SET_GLOBAL_MESSAGE)(message); };
//# sourceMappingURL=actions.js.map